(function(){
  function debounce(fn, wait){ let t; return function(){ clearTimeout(t); t = setTimeout(fn, wait); }; }

  function initMarquee(section){
    // ensure animation doesn't start until JS measures and sets the duration
    section.classList.remove('marquee--running');
    section.classList.remove('marquee--paused');

    let speed = Number(section.dataset.speed);
    if (Number.isNaN(speed)) speed = 30; // default
    const track = section.querySelector('.marquee__track');
    const marqueeEl = section.querySelector('.marquee');
    if (!track || !marqueeEl) return;

    let inners = Array.from(track.querySelectorAll('.marquee__inner'));
    let firstInner = inners[0];
    if (!firstInner) return;

    // ensure at least two copies exist (we render repeated content server-side, but keep this as a fallback)
    if (inners.length < 2) {
      const clone = firstInner.cloneNode(true);
      track.appendChild(clone);
      inners = Array.from(track.querySelectorAll('.marquee__inner'));
      firstInner = inners[0];
    }

    const update = () => {
      // measure
      const containerWidth = Math.ceil(marqueeEl.getBoundingClientRect().width);
      const itemWidth = Math.max(0, Math.ceil(firstInner.getBoundingClientRect().width));
      if (!itemWidth) return;

      // if the first inner isn't wide enough to fill viewport, append extra copies so halves line up
      const totalTrackWidth = itemWidth * track.querySelectorAll('.marquee__inner').length;
      const neededCopies = Math.ceil((containerWidth * 2) / itemWidth);
      while (track.querySelectorAll('.marquee__inner').length < Math.max(2, neededCopies)) {
        const clone = firstInner.cloneNode(true);
        track.appendChild(clone);
      }

      // handle special case: speed <= 0 => paused
      if (speed <= 0) {
        section.classList.remove('marquee--running');
        section.classList.add('marquee--paused');
        return;
      } else {
        section.classList.remove('marquee--paused');
      }

      // increase sensitivity so small slider moves have more effect (multiplier = 3.0)
      const effectiveSpeed = Math.max(0.001, speed * 3.0);

      // duration = pixels / effectiveSpeed — move by the width of one 'inner' per cycle
      const duration = Math.max(2, (itemWidth / effectiveSpeed));
      section.style.setProperty('--marquee-duration', duration + 's');

      // start animation after duration is set to avoid flash
      section.classList.add('marquee--running');
    };

    // initial + after fonts/images load
    setTimeout(update, 50);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
    window.addEventListener('resize', debounce(update, 120));
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.marquee-section').forEach(initMarquee);
  });

  // Re-init when Shopify sections are reloaded in editor
  document.addEventListener('shopify:section:load', function(e){
    const section = e.target.querySelector('.marquee-section');
    if (section) initMarquee(section);
  });
})();
